// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__3hJx-","obliqueLineWrap":"membershipbadge_obliqueLineWrap__ZmK93","obliqueLine":"membershipbadge_obliqueLine__3Q3pR"};